// components/HeroSection.tsx
import React, { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

// Import your images
import wedImg1 from "../../assets/wedImg1.jpeg";
import wedImg2 from "../../assets/wedImg2.jpeg";
import ampersand from "../../assets/ampersand.png";

const HeroSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const images = [wedImg2];

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  // Auto-advance carousel on mobile
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(timer);
  }, [images.length]);

  return (
    <section className="w-full relative  bg-white">
      {/* Desktop View */}
      <div className="hidden lg:block relative py-10 px-8">
        <div className="relative w-full max-w-7xl mx-auto">
          {/* Stacked Images Container - Centered */}
          <div className="relative h-auto w-full flex items-center justify-center">
            {/* Images Wrapper - Wider container for 7xl */}
            <div className="relative w-full max-w-[1100px] h-[650px]">
              {/* First Image (Behind - like blue box) - Upper left */}
              <div
                data-aos="fade-right"
                data-aos-delay="100"
                className="absolute left-[10%] top-0 z-10"
              >
                <img
                  src={wedImg1}
                  alt="Couple 1"
                  className="w-[480px] h-[580px] object-cover grayscale shadow-2xl"
                />
              </div>

              {/* Second Image (In Front - like pink box) - Overlapping, lower right */}
              <div
                data-aos="fade-left"
                data-aos-delay="300"
                className="absolute right-[10%] bottom-0 z-20"
              >
                <img
                  src={wedImg2}
                  alt="Couple 2"
                  className="w-[480px] h-[580px] object-cover grayscale shadow-2xl"
                />
              </div>

              {/* J & J Overlay - Centered on the overlap */}
              <div className="absolute inset-0 z-30 pointer-events-none">
                <div className="relative w-full h-full flex items-center justify-center">
                  <div className="relative">
                    {/* First J - Upper left */}
                    <span
                      data-aos="fade-down"
                      data-aos-delay="200"
                      className="absolute text-white text-[240px] font-serif"
                      style={{
                        fontFamily: "'Times New Roman', Times, serif",
                        fontWeight: 400,
                        left: "-50px",
                        top: "-130px",
                        textShadow: "0 4px 20px rgba(0,0,0,0.4)",
                      }}
                    >
                      J
                    </span>

                    {/* Ampersand Image */}
                    <img
                      src={ampersand}
                      alt="&"
                      className="w-[200px] h-auto object-contain drop-shadow-[0_4px_20px_rgba(0,0,0,0.4)]"
                      style={{
                        filter: "brightness(0) invert(1)",
                      }}
                      data-aos="zoom-in"
                      data-aos-delay="300"
                    />

                    {/* Second J - Lower right */}
                    <span
                      data-aos="fade-up"
                      data-aos-delay="400"
                      className="absolute text-white text-[240px] font-serif"
                      style={{
                        fontFamily: "'Times New Roman', Times, serif",
                        fontWeight: 400,
                        right: "-50px",
                        bottom: "-130px",
                        textShadow: "0 4px 20px rgba(0,0,0,0.4)",
                      }}
                    >
                      J
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile View - Carousel */}
      <div className="lg:hidden relative">
        {/* Carousel Container */}
        <div className="relative w-full h-[70vh] overflow-hidden">
          {images.map((img, index) => (
            <div
              key={index}
              className={`absolute inset-0 transition-opacity duration-500 ${
                currentSlide === index ? "opacity-100" : "opacity-0"
              }`}
            >
              <img
                src={img}
                alt={`Couple ${index + 1}`}
                className="w-full h-full object-cover grayscale"
              />
            </div>
          ))}

          {/* J & J Overlay for Mobile */}
          <div className="absolute inset-0 z-30 pointer-events-none">
            <div className="relative w-full h-full flex items-center justify-center">
              <div className="relative">
                {/* First J - Upper left */}
                <span
                  data-aos="fade-down"
                  data-aos-delay="200"
                  className="absolute text-white text-[130px] font-serif"
                  style={{
                    fontFamily: "'Times New Roman', Times, serif",
                    fontWeight: 400,
                    left: "-30px",
                    top: "-80px",
                    textShadow: "0 4px 20px rgba(0,0,0,0.4)",
                  }}
                >
                  J
                </span>

                {/* Ampersand Image */}
                <img
                  src={ampersand}
                  alt="&"
                  className="w-[120px] h-auto object-contain drop-shadow-[0_4px_20px_rgba(0,0,0,0.4)]"
                  style={{
                    filter: "brightness(0) invert(1)",
                  }}
                  data-aos="zoom-in"
                  data-aos-delay="300"
                />

                {/* Second J - Lower right */}
                <span
                  data-aos="fade-up"
                  data-aos-delay="400"
                  className="absolute text-white text-[130px] font-serif"
                  style={{
                    fontFamily: "'Times New Roman', Times, serif",
                    fontWeight: 400,
                    right: "-30px",
                    bottom: "-80px",
                    textShadow: "0 4px 20px rgba(0,0,0,0.4)",
                  }}
                >
                  J
                </span>
              </div>
            </div>
          </div>

          {/* Carousel Indicators */}
          <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex gap-3 z-40">
            {images.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`h-[2px] transition-all duration-300 ${
                  currentSlide === index ? "w-8 bg-white" : "w-6 bg-white/50"
                }`}
              />
            ))}
          </div>

          {/* Gold Floral Decoration - Bottom Right (Mobile) */}
          {/* <img
            src={floralGraphic}
            alt="Floral decoration"
            data-aos="fade-up"
            className="absolute bottom-0 right-0 w-24 opacity-90 z-30"
          /> */}
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
